import Swiper from 'swiper';

const sliderPageList = document.getElementById('home-slider');

let numberOfSlides = 0;
if (sliderPageList && sliderPageList.dataset && sliderPageList.dataset.numberOfSlides) {
    numberOfSlides = parseInt(sliderPageList.dataset.numberOfSlides, 10) || 0;
    console.log('Slider został zainicjalizowany:', numberOfSlides);
}

function initSliderPageList() {
    if (!sliderPageList || numberOfSlides <= 1) return;

    const sliderPL = new Swiper(sliderPageList, {
        slidesPerView: 1,
        spaceBetween: 150,
        loop: true,
        speed: 1300,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: '.home-swiper-button-next',
            prevEl: '.home-swiper-button-prev',
        },
    });

}

document.addEventListener('DOMContentLoaded', () => {
    initSliderPageList();
});
